<div class="login-wrapper">
  <app-header></app-header>
  
  <div class="login-containers">
    <div class="login-box">
      <!-- Logo Section -->
      <div class="logo-section">
        <img src="assets/icon/gigsumologo_bigface.png" alt="Gigsumo" class="logo">
      </div>

      <!-- Welcome Text -->
      <div class="welcome-text">
        <h1>Login to gigsumo.com</h1>
        <!-- <p>Sign in to continue to Gigsumo</p> -->
      </div>

      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="loginform()" class="login-form">
        <!-- Error Message -->
        <div class="error-message" *ngIf="loginForm.errors?.['apiError']">
          <ng-icon name="tablerAlertCircle"></ng-icon>
          {{loginForm.errors?.['apiError']}}
        </div>

        <!-- Email Input -->
        <div class="input-group">
          <input
            type="email"
            class="form-input"
            placeholder="Email Address"
            formControlName="username"
            #usernameInput
            id="login_email"
            tabindex="1"
            maxlength="51"
            (focus)="$event.target.select()"
            [class.error]="login.username.invalid && (login.username.dirty || login.username.touched)">
          <span class="input-icon">
            <ng-icon name="tablerMail"></ng-icon>
          </span>
          <div class="login-error-msg-right" *ngIf="login.username.invalid && (login.username.dirty || login.username.touched)">
            <span *ngIf="login.username.errors.required">Email is required</span>
            <span *ngIf="login.username.errors.pattern">Please enter a valid email</span>
            <span *ngIf="login.username.errors.maxword && !login.username.errors.pattern">Maximum 50 characters</span>
          </div>
        </div>

        <!-- Password Input -->
        <div class="input-group">
          <input
            [type]="passwordShown ? 'text' : 'password'"
            class="form-input"
            placeholder="Password"
            formControlName="password"
            id="login_password"
            tabindex="2"
            maxlength="50"
            (paste)="(false)"
            (focus)="$event.target.select()"
            [class.error]="login.password.invalid && (login.password.dirty || login.password.touched)">
          <span class="input-icon">
            <ng-icon name="tablerLock"></ng-icon>
          </span>
          <button type="button" class="password-toggle" tabindex="-1"
                  [attr.aria-label]="passwordShown ? 'Hide password' : 'Show password'"
                  (click)="passwordShown = !passwordShown">
            <ng-icon *ngIf="!passwordShown" name="tablerEye"></ng-icon>
            <ng-icon *ngIf="passwordShown" name="tablerEyeOff"></ng-icon>
          </button>
          <div class="login-error-msg-right" *ngIf="login.password.invalid && (login.password.dirty || login.password.touched)">
            <span *ngIf="login.password.errors.required">Password is required</span>
          </div>
        </div>

        <!-- Remember & Forgot -->
        <div class="form-actions">
          <!-- <label class="remember-check">
            <input type="checkbox">
            <span>Remember me</span>
          </label> -->
          <a [routerLink]="['/auth/Forgotpassword']" class="forgot-password" tabindex="3" id="forgotpassword">
            Forgot password?
          </a>
        </div>

        <!-- Sign In Button -->
        <button id="login_signin_button" type="submit" class="sign-in-btn" tabindex="4" [disabled]="loginbtnDisable"
          (focus)="$event.target.classList.add('focused')"
          (blur)="$event.target.classList.remove('focused')">
          <span *ngIf="!loginbtnDisable">Sign In</span>
          <span *ngIf="loginbtnDisable">
            <ng-icon name="tablerLoader2" class="spin"></ng-icon> Sign In...
          </span>
        </button>

        <!-- OR Divider -->
        <div class="divider-section">
          <span class="divider-text">OR</span>
        </div>

        <!-- Google Sign In -->
        <button type="button" class="google-sign-in" tabindex="5" (click)="redirectToGoogle()">
          <img src="assets/images/g-logo.png" alt="Google">
          <span>Continue with Google</span>
        </button>
      </form>

      <!-- Sign Up Link -->
      <div class="sign-up-section">
        <span>New to Gigsumo?</span>
        <a [routerLink]="['/auth/signUp']" tabindex="6">Create an account</a>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>